import { useContext } from "react";
import { psPdfContext } from "../context/psPdfContext";

export const usePsPdfKit = () => useContext(psPdfContext);
